<script setup lang="ts">
import { APP_TIMEZONE } from "@/constants";
import { Temporal } from "@js-temporal/polyfill";
import { computed, type InputHTMLAttributes } from "vue";

const isoDate = defineModel<string | null>({ required: true });

defineProps</* @vue-ignore */ InputHTMLAttributes>();

defineOptions({ inheritAttrs: false });

const localDateTime = computed({
  get: () => {
    if (isoDate.value === null) return "";

    return Temporal.Instant.from(isoDate.value)
      .toZonedDateTimeISO(APP_TIMEZONE)
      .toPlainDateTime()
      .toString();
  },
  set: (value: string) => {
    if (value === "") {
      isoDate.value = null;
      return;
    }
    isoDate.value = Temporal.PlainDateTime.from(value)
      .toZonedDateTime(APP_TIMEZONE)
      .toInstant()
      .toString();
  },
});
</script>

<template>
  <input v-model="localDateTime" type="datetime-local" v-bind="$attrs" />
</template>
